module.exports = __webpack_public_path__ + "static/media/logo.2c8246fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/gifs/logo.svg
// module id = 156
// module chunks = 0